// эта штука, чтобы не плодить файлы содержимым en.json для стран, для которых еще не готовы переводы
export const MESSAGES_MAP: Record<string, string> = {
  ru: 'ru',
  en: 'en',
  ch: 'cn', // ch у переводчиков это Чамо́рро (чамор. Estorian Chamoru, англ. Chamorro) — коренные жители острова Гуам.
  // используем 'cn', который тоже невалидный, но пришел из бойлера
  // при этом файл ch.json удалять нельзя, потому что он используется secureMiddleware для построения роутов
  tr: 'tr',
  tj: 'en',
  ka: 'ka',
  hy: 'hy',
  kk: 'kk',
  uz: 'uz',
};
